// if the module has no dependencies, the above pattern can be simplified to
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define([], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        var parameterNames = factory();
        // Browser globals (root is window)
        var qr = root.qd.qRules;

        // legacy alias - still used in 3 files as of 2025-03-28:
        // - CreateSharePointFolder
        // - Decrypt
        // - Encrypt
        qr.Constants = parameterNames;
    }
})(typeof self !== 'undefined' ? self : this, function () {
    return {
        //A
        paramAction: 'action',
        paramAllowExternal: 'allowexternal',
        paramAppend: 'append',
        paramAsync: 'async',
        paramAttachment: 'attachment',
        paramAttr: 'attr',
        paramAutoOpen: 'autoopen',
        //B
        paramBlank: 'blank',
        //C
        paramChild: 'child',
        paramClear: 'clear',
        paramCompare: 'compare',
        paramContent: 'content',
        paramContentType: 'contenttype',
        paramContentTypeIsId: 'contenttypeisid',
        paramContextNode: 'contextnode',
        paramCreateDirectory: 'createdirectory',
        paramCtrlId: 'ctrlid',
        paramCulture: 'culture',
        //D
        paramData: 'data',
        paramDate: 'date',
        paramDay: 'day',
        paramDays: 'days',
        paramDecode: 'decode',
        paramDefault: 'default',
        paramDefinitionName: 'definitionname',
        paramDefinitionSource: 'definitionsrc',
        paramDestDs: 'destds',
        paramDestPath: 'destpath',
        paramDetectName: 'detectname',
        paramDocId: 'docid',
        paramDocIdXPath: 'docidxpath',
        paramDomainId: 'domainid',
        paramDownload: 'download',
        paramDsName: 'dsname',
        paramDsNameDest: 'dsnamedest',
        paramDsNameHol: 'dsnamehol',
        paramDsNamePass: 'dsnamepass',
        paramDsNameProg: 'dsnameprog',
        paramDsNameSrc: 'dsnamesrc',
        paramDsNameWs: 'dsnamews',
        paramDsSubmit: 'dssubmit',
        paramDsUrl: 'dsurl',
        //E
        paramEmpty: 'empty',
        paramEval: 'eval',
        paramExcludeSourceRoot: 'excludesourceroot',
        //F
        paramFileName: 'filename',
        paramFooterAlignment: 'footeralignment',
        paramFooterFontFamily: 'footerfontfamily',
        paramFooterFontSize: 'footerfontsize',
        paramFooterText: 'footertext',
        paramFormat: 'format',
        paramFullPathAttributeName: 'fullpathattributename',
        //G
        paramGetDocument: 'getdocument',
        paramGuess: 'guess',
        //H
        paramHeaderAlignment: 'headeralignment',
        paramHeaderFontFamily: 'headerfontfamily',
        paramHeaderFontSize: 'headerfontsize',
        paramHeaderNamePath: 'headernamepath',
        paramHeaderText: 'headertext',
        paramHeaderValuePath: 'headervaluepath',
        paramHeadersDsName: 'headersdsname',
        paramHeadersPath: 'headerspath',
        paramHeight: 'height',
        paramHours: 'hours',
        //I
        paramId: 'id',
        paramIncludeButtons: 'includebuttons',
        paramInner: 'inner',
        //J
        paramJson: 'json',
        //K
        paramKey: 'key',
        paramKeyXPath: 'keyxpath',
        //L
        paramLastModifiedLocalAttributeName: 'lastmodifiedlocalattributename',
        paramLibrary: 'library',
        paramList: 'list',
        paramListGuid: 'listguid',
        paramListName: 'listname',
        paramLocation: 'location',
        //M
        paramMapping: 'mapping',
        paramMappingName: 'mappingName',
        paramMaxHeight: 'maxheight',
        paramMaxLength: 'maxlength',
        paramMaxWidth: 'maxwidth',
        paramMethod: 'method',
        paramMessage: 'message',
        paramMinutes: 'minutes',
        paramMode: 'mode',
        paramMonths: 'months',
        paramMoveNext: 'movenext',
        //N
        paramName: 'name',
        paramNameXPath: 'namexpath',
        paramNil: 'nil',
        paramNoValidate: 'novalidate',
        //O
        paramOpen: 'open',
        paramOrder: 'order',
        paramOuter: 'outer',
        paramOutput: 'output',
        paramOverwrite: 'overwrite',
        //P
        paramPad: 'pad',
        paramParametersAllowNullPath: 'parametersallownullpath',
        paramParametersDsName: 'parametersdsname',
        paramParametersNamePath: 'parametersnamepath',
        paramParametersTypePath: 'parameterstypepath',
        paramParametersValuePath: 'parametersvaluepath',
        paramParametersXpath: 'parametersxpath',
        paramParent: 'parent',
        paramParentPath: 'parentpath',
        paramPass: 'pass',
        paramPassword: 'password',
        paramPath: 'path',
        paramPathSep: 'pathsep',
        paramPattern: 'pattern',
        paramProperties: 'properties',
        //Q
        paramQdImage: 'qdimage',
        //R
        paramRate: 'rate',
        paramRelDest: 'reldest',
        paramRepeater: 'repeater',
        paramResultDs: 'resultdestds',
        paramResultPath: 'resultxpath',
        paramRow: 'row',
        paramRowDest: 'rowdest',
        paramRowSrc: 'rowsrc',
        //S
        paramSeconds: 'seconds',
        paramSeparator: 'separator',
        paramSiteUrl: 'siteurl',
        paramSource: 'source',
        paramSourceDs: 'sourceds',
        paramSourceFile: 'sourcefile',
        paramSourcePath: 'sourcepath',
        paramSpace: 'space',
        paramSql: 'sql',
        paramString1: 'string1',
        paramString2: 'string2',
        paramSubmit: 'submit',
        //T
        paramTableDest: 'tabledest',
        paramTableSrc: 'tablesrc',
        paramTemplateName: 'templatename',
        paramTermId: 'termId',
        paramText: 'text',
        paramTimeout: 'timeout',
        paramTimeoutms: 'timeoutms',
        paramType: 'type',
        //U
        paramUniqueName: 'uniquename',
        paramUnload: 'unload',
        paramUpdate: 'update',
        paramUpgradeDocument: 'upgradedocument',
        paramUrl: 'url',
        paramUseKeyVariable: 'usekeyvariable',
        paramUseProxy: 'useproxy',
        paramUser: 'user',
        paramUsername: 'username',
        paramUseUrlVariable: 'useurlvariable',
        //V
        paramValue: 'value',
        paramValues: 'values',
        paramVersion: 'version',
        paramView: 'view',
        paramViews: 'views',
        //W
        paramWebService: 'webservice',
        paramWeekdays: 'weekdays',
        paramWeeks: 'weeks',
        paramWhere: 'where',
        paramWidth: 'width',
        //X
        // BUGBUG - Inconsistent capitalization of XPath in variable names
        paramXPath: 'xpath',
        paramXpathDest: 'xpathdest',
        paramXpathHol: 'xpathhol',
        paramXPathNode: 'xpathnode',
        paramXPathProg: 'xpathprog',
        paramXPathSrc: 'xpathsrc',
        //Y
        paramYears: 'years',
        //Z
    };
});
